import { useAuth } from "@/context/AuthContext";
import { Eye, X } from "lucide-react";

export function ImpersonationBanner() {
  const { user, stopImpersonation } = useAuth();
  if (!user?.impersonator_id) return null;

  const targetLabel = user.role === "shop"
    ? (user.shop_name || user.name)
    : (user.anonymous_handle || user.name);

  return (
    <div className="sticky top-0 z-[60] bg-[#FF3B30] text-white" data-testid="impersonation-banner">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 lg:px-12 py-2.5 flex items-center justify-between gap-3 text-sm">
        <div className="flex items-center gap-3 min-w-0">
          <Eye className="w-4 h-4 shrink-0" strokeWidth={2.5} />
          <span className="uppercase tracking-widest text-xs font-bold shrink-0">ADMIN VIEW</span>
          <span className="opacity-90 truncate">
            Acting as <span className="font-bold">{targetLabel}</span> ({user.role})
          </span>
        </div>
        <button
          onClick={stopImpersonation}
          className="flex items-center gap-1.5 text-xs uppercase tracking-widest font-bold hover:bg-white/10 px-3 py-1.5 transition-colors"
          data-testid="stop-impersonation-btn"
        >
          Return to admin <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}
